import createClient, { Middleware } from "openapi-fetch";
import type { paths } from "@telegraphio/bapi-types/schema";
import { ApiError } from "@/bapi-client/errors";

const baseUrl = import.meta.env.VITE_API_URL || "https://prod-b-api.telegraph.io";

// Custom types that extends the openapi-fetch response structure
export type CustomFetchError = {
  status: string;
  message: string;
  title: string;
  success: boolean;
};

export type CustomFetchResponse<T> =
  | {
      data: T;
      error?: never;
      response: Response;
    }
  | {
      data?: never;
      error: CustomFetchError;
      response: Response;
    };

export function handleApiError(error: unknown, response: Response | undefined, fallbackMessage: string): never {
  const errorMessage = Array.isArray(error)
    ? error.map((e) => e.msg).join(", ")
    : (error as CustomFetchError)?.message || fallbackMessage;

  throw ApiError.create(errorMessage, response?.status, error);
}

const OPEN_ROUTES = ["/user/login/sso", "/auth/callback"];

const clientSetup: Middleware = {
  async onRequest({ request, schemaPath }) {
    if (OPEN_ROUTES.some((path) => schemaPath.startsWith(path))) {
      return undefined;
    }
    const token = localStorage.getItem("authToken");
    if (token) {
      request.headers.set("Authorization", `Bearer ${token}`);
    }
    return request;
  },
  async onError({ error }) {
    console.error("API Error:", error);
    return new Error("An error occurred while processing your request.", { cause: error });
  },
};

const apiClient = createClient<paths>({
  baseUrl,
});

apiClient.use(clientSetup);

export default apiClient;
